const location = {
  address1: "",
  address2: "",
  addresses: [],
  phone: [],
  email: [],
  coordinate: {},
  hours: [],
};

export default location;
